import { ApiService }           from '../../app-lite/api/api.service';
import { CompanyMessagesModel } from '../../app-lite/companies/models/company.messages';
import { TableService }         from '../../app-lite/table/table.service';

import BookingRequestsHtml  from './booking.requests.html';
import BookingsSettingsHtml from './bookings.settings.html';

export function BookingsStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    abstract: true,
    name    : 'app.bookings',
    url     : '/bookings'
  })
  .state({
    controller : 'BookingRequestsCtrl',
    name       : 'app.bookings.requests',
    templateUrl: BookingRequestsHtml,
    url        : '/requests',
    resolve    : {
      appointmentTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/event_appointment_types'),
      company         : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      companyMessages : ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      requests        : ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/event_requests', [ 0, (tableApi.getCacheForTable('bookingRequests').paging.pageSize + 1) || 11 ])
    }
  })
  .state({
    controller : 'BookingsSettingsCtrl',
    name       : 'app.bookings.settings',
    templateUrl: BookingsSettingsHtml,
    url        : '/settings',
    resolve    : {
      appointmentTypes: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/appointment_types', [ 0, (tableApi.getCacheForTable('bookingAppointmentTypes').paging.pageSize + 1) || 11 ]),
      maskedCompanyId : ( workshopAPI : ApiService ) : Promise<string> => workshopAPI.get('/company_settings/public_booking_api_company_id').then(response => response.company_id),
      settings        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_settings')
    }
  });
}